
import { apiService, RoleStatusResponse } from '../core/api.service';

export namespace AccountService {

  export async function loadRoleStatusByAccountId(accountId: string) {
    try {
      const response = await apiService.get<RoleStatusResponse>('/core/get-role-status', {
        queryStringParameters: { accountId }
      });
      return response;
    } catch (error) {
      throw error; // Re-throw the standardized error from apiService
    }
  }
}
